import React, { Component } from 'react';
import ETruckImg from '../Static/eTruck/DSC02330.jpg';
import RecycleImg from '../Static/eTruck/recyclelogo.jpg';
import ChangeLocale from "../Components/changeLocale";
import GoBack from "../Components/goBack";
import {FormattedMessage, FormattedHTMLMessage} from "react-intl";

class ETruck extends Component {
	render() {
		const { locale, changeLocale } = this.props;

		return (
			<>
				<GoBack />
				<ChangeLocale locale={locale} changeLocale={changeLocale} />
				<h2><FormattedMessage id='eTruck' /></h2>

				{/*<div className='row justifyContent--space'>*/}
				{/*	<div style={{ width: '300px' }} className='text-align--left'>*/}
				{/*		Odvezie naraz až 250kg<br/>*/}
				{/*		Nabíjanie: 8 hod<br/>*/}
				{/*		 Rýchlosti: 0 -3,5 MPH variabilný výkon <br/>*/}
				{/*		Vybavený systémom 4WD*/}
				{/*	</div>*/}
				{/*	<img decoding="async" height='120' width='120' alt='recycle' src={RecycleImg} />*/}
				{/*	<img decoding="async" className='gallery-picture' src={ETruckImg} alt='e-truck' />*/}
				{/*</div>*/}

				<div className='row justifyContent--space'>
					<div style={{ width: '300px' }} className='text-align--left'>
						<FormattedHTMLMessage id='eTruckParameters' />
					</div>
					<img decoding="async" height='120' width='120' alt='recycle' src={RecycleImg} />
					<img decoding="async" className='gallery-picture' src={ETruckImg} alt='e-truck' />
				</div>

				<p>
					<b><FormattedMessage id='thisIsWheelBarrowWithDifference' /></b><br/>
				</p>
				<p><FormattedMessage id='eTruckContent' /></p>

				{/*<p>*/}
				{/*	<b>Toto je kolesová trať s rozdielom.</b><br/>*/}
				{/*	E-TRUCK od spoločnosti Mucktruck je nová inovácia pre tých z vás, ktorí hľadajú produkt, ktorý má všetky prednosti a vlastnosti všetkých našich strojov, ale aj schopnosť pracovať v baniach, budovách alebo iných oblastiach, kde  hluk a dym zo spaľovacieho motora sú nevhodné.*/}
				{/*</p>*/}
				{/*<p>E-TRUCK je poháňaný  poháňanými štyrmi 12-voltovými batériami, ktoré sú jedinečným spôsobom zapojené do výstupu 24 V na prenos, takže výkon pre výstup alebo prenášanie materiálov je rovnako dobrý ako motorom poháňané stroje. Na jedno nabitie môže pracovať nepretržite až 3,5 hodiny.</p>*/}
				{/*<p>E – Truck Má rovnakú silu a kvalitu, ako  ostatné stroje od Muck - Truck, ale je šetrnejší k životnému prostrediu.</p>*/}
			</>
		);
	}
}

export default ETruck;
